/**
 * Overrides browser-native HTML5 validation tooltips with Serbian messages.
 * Attach once at the document level — captures all form elements.
 */
export function initSerbianValidation(): void {
    document.addEventListener('invalid', (e) => {
        const el = e.target as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
        if (!el || !('setCustomValidity' in el)) return;
        el.setCustomValidity(''); // reset so validity.* reflects actual state

        const v = el.validity;
        if (v.valueMissing) {
            el.setCustomValidity(
                el.tagName === 'SELECT' ? 'Molimo izaberite stavku sa liste.' : 'Ovo polje je obavezno.'
            );
        } else if (v.typeMismatch) {
            const type = (el as HTMLInputElement).type;
            if (type === 'email') el.setCustomValidity('Unesite ispravnu email adresu.');
            else if (type === 'url') el.setCustomValidity('Unesite ispravnu URL adresu.');
            else el.setCustomValidity('Vrednost nije u ispravnom formatu.');
        } else if (v.tooShort) {
            el.setCustomValidity(`Minimum ${el.minLength} karaktera.`);
        } else if (v.tooLong) {
            el.setCustomValidity(`Maksimum ${(el as HTMLInputElement).maxLength} karaktera.`);
        } else if (v.rangeUnderflow) {
            el.setCustomValidity(`Vrednost mora biti najmanje ${(el as HTMLInputElement).min}.`);
        } else if (v.rangeOverflow) {
            el.setCustomValidity(`Vrednost mora biti najviše ${(el as HTMLInputElement).max}.`);
        } else if (v.patternMismatch) {
            el.setCustomValidity('Format nije ispravan.');
        } else if (v.stepMismatch) {
            el.setCustomValidity('Vrednost nije u ispravnom koraku.');
        }
    }, true);

    // Clear the custom message on input so it doesn't persist after correction.
    document.addEventListener('input', (e) => {
        const el = e.target as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
        if (el && 'setCustomValidity' in el) el.setCustomValidity('');
    }, true);
}
